<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Arıza Tipi Ana Grubu</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" v-model="value.Name" class="form-control" placeholder="Arıza Tipi Ana Grubu"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Sıra</label>
            <v-validator :errors="errors" parameter="OrderNumber" :watch="value.OrderNumber">
                <input type="number" v-model="value.OrderNumber" class="form-control" placeholder="Sıra"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>